// A fieldset[disabled] stops propagation of mouse events in Firefox.
// Event-bound code like an `[up-layer]` compiler would not work.
//
// There is no way to change this in Firefox. We use a `no-edit` attribute
// instead, and disable all fields manually.

const disableElementSelectors = up.form.config.fieldSelectors.map(field => `[no-edit="true"] ${field}`).join(', ')
const hideElementSelectors = ['[no-edit="true"] [hide-if-no-edit="true"]'].join(', ')

up.compiler(disableElementSelectors, function(element) {
  if(element.getAttribute('enabled') == undefined) {
    element.disabled = true
  }
})

up.compiler(hideElementSelectors, function(element) {
  if(element.getAttribute('enabled') == undefined) {
    element.classList.add('d-none')
  }
})
